import styles from "./ErrorMsg.module.css";

export default function ErrorMsg(props: { msg: string; isShown: boolean }) {
    if (props.isShown) {
        return <div className={styles.content}>{props.msg}</div>;
    } else {
        return <></>;
    }
}
